import { createContext } from 'solid-js';
import { Server } from './types';

export type MyStore = {
  servers: { [address: string]: Server };
};

export const StoreContext = createContext<MyStore>();
